<template>
    <div>
        <!-- detail_f -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>Title</th>
                    <td>{{data[0].TITLE}}</td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td>{{data[0].TYPE}}</td>
                </tr>
                <tr>
                    <th>Country/Region</th>
                    <td>{{data[0].COUNTRY_NM}}</td>
                </tr>

                <tr>
                    <th>SKU Code</th>
                    <td>{{data[0].SKU_CODE}}</td>
                </tr>
                <tr>
                    <th>Model</th>
                    <td>{{data[0].NMMODEL}}</td>
                </tr>
                <tr>
                    <th>Buyer</th>
                    <td>{{data[0].BUYER_CODE}}</td>
                </tr>
                <tr>
                    <th>Attachment</th>
                    <td class="no_padding">
                        <innorix-download
                            :uploadId="data.CTTID"
                            serviceType="hhp"
                            :attachList="data"
                            :encToken="encToken"
                        />

                        <dl class="attachment_link" v-if="data.length > 0">
                            <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                            <dd>
                                <ul>
                                    <li v-for="(file,index) in data" :key="index">
<!--                                 [Vue warn]: Duplicate keys detected: 'NaN'. This may cause an update error. -->
<!--                                     <li v-for="file in data" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"> -->
                                        <!-- <a :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" download="true" target="_blank" class="txt_link"> -->
                                        <a :href="getDownloadUrl(file)" target="_blank" class="txt_link" download type="application/octet-stream">
                                            <span class="ico_attach"></span> {{ file.FILENAME }}
                                        </a>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                        <div v-else>
                            No Attachment
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="topLine"></div>
        <!-- //detail -->
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';

import SDLUtil from '@/utils/SDLUtil';
import InnorixDownload from '~c/InnorixDownload';

export default {
    name: 'anysvcFindContentView',
    components: {
        'innorix-download': InnorixDownload,
    },
    // props: {
    //     CTTID: { type: String, default: '', },
    //     NMMODEL: { type: String, default: '', },
    //     CDCODE: { type: String, default: '', },
    //     BUYER_CODE: { type: String, default: '', },
    //     COUNTRY_NM: { type: String, default: '', },
    //     SKU_CODE: { type: String, default: '', },
    //     COUNTRY_CD: { type: String, default: '', },
    // },
    props: [
        'data', // TITLE, TYPE, NMMODEL, CTTFILESIZE, COUNTRY_NM, VNAME, VPATH,
        'encToken',
        //  SIDCREATE,DTCREATE
    ],
    data() {
        return {
        };
    },
    computed: {
        // VPATH: `${attach.VPATH}/${attach.FILENAME}`,
        // TYPE: `${attach.TYPE}`,
        // CTTID: `${attach.CTTID}`,
        // CTTTYPE: `${attach.CTTTYPE}`,
        // NMMODEL: `${attach.NMMODEL}`,
        // COUNTRY_CD: `${attach.COUNTRY_CD}`,
        // CATEGORY: `${attach.CATEGORY}`,
        // BUYER: `${attach.BUYER}`,
    },
    created() {},
    mounted() {
        // console.log("Content View Data: ", this.data);
        // console.log("Content View Token: ", this.encToken);
    },
    methods: {
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },

        getDownloadUrl(file) {
            const params = {
                VPATH: `${file.VPATH}`,
                TYPE: `${file.TYPE}`,
                CTTID: `${file.CTTID}`,
                CTTTYPE: `${file.CTTTYPE}`,
                NMMODEL: `${file.NMMODEL}`,
                COUNTRY_CD: `${file.COUNTRY_CD}`,
                CATEGORY: `${file.CATEGORY}`,
                BUYER: `${file.BUYER}`,
                encToken: this.encToken,
            };
            const downloadUrl = `${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContentDownLoad.skp?${qs.stringify(params)}`;
            //return window.open(downloadUrl);
            return downloadUrl;
        },
        // initLoad() {
        //     const data = {
        //         CTTID: this.CTTID,
        //         NMMODEL: this.NMMODEL,
        //         CDCODE: this.CDCODE,
        //         country_show_detail: this.COUNTRY_NM,
        //         buyer: this.BUYER_CODE,
        //     };
        //     return axios
        //         .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContentDetail.skp`,
        //             { params: data })
        //         .then(resp => {
        //             // Data from List need to be added to the Detail data
        //             this.data = Object.assign({}, resp.data.result.row);
        //             // this.data.CDCODE = this.COUNTRY_CD;
        //             // this.data.COUNTRY_NM = this.COUNTRY_NM;
        //             // this.data.SKU_CODE = this.SKU_CODE;
        //             // this.data.BUYER_CODE = this.BUYER_CODE;
        //             // console.log('VIEW DATA', this.viewData);
        //         })
        //         .catch(err => {
        //             Vue.$log.error(err);
        //         });
        // },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/findContent/FindContentView.vue